// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"700":"fecf2e78","855":"4be1a097"}[chunkId] + ".chunk.js";
};